module.exports = __webpack_public_path__ + "media/images/home/logo-c7f8237172abeb7e5b7ebd1100c8fcd7.svg";